/**
 * A production's name without its trailing internal code.
 *
 * EncorePro names carry the box-office code in brackets at the end ("Wicked [ANLIGW]").
 * The code means nothing to an agency or a show, so the campaigns list drops it
 * (Gio, 2026-10-22). Only a bracketed code of letters and digits at the very end is
 * removed; a name that is nothing but a code is kept whole.
 */
export function productionDisplayName(name: string): string {
  const stripped = name.replace(/\s*\[[A-Z0-9]{2,12}\]\s*$/, '');
  return stripped.trim() === '' ? name : stripped;
}
